module.exports = __webpack_public_path__ + "img/canam-devices.ed978455.png";